<script>
    import { productCardMixin } from "@/mixins/product-card";
    import ProductCardImage from "@/components/product/ProductCardImage";
    import ProductCardButtons from "@/components/product/ProductCardButtons";
    import ProductColorsList from "@/components/product/ProductColorsList";
    import ProductPrice from "@bivan/components/ProductPrice";

    export default {
        name: "ProductCard",
        components: {
            ProductCardImage,
            ProductCardButtons,
            ProductColorsList,
            ProductPrice,
        },
        props: {
            product: Object,
            position: Number,
            isSmall: Boolean,
            inCartList: Array,
        },
        mixins: [productCardMixin],
    };
</script>

<template>
    <div class="product-card" :class="{ 'product-card--sm': isSmall }">
        <div class="product-card__img">
            <div v-if="discountPercent" class="product-card__sale-label">
                -{{ discountPercent }}%
            </div>

            <product-card-image
                :image="previewImage"
                :offer-image="offerImage"
                :path="productPath"
                @click="sendDataLayerEvent"
            >
                <preloader :show="true" lg-size></preloader>
            </product-card-image>
        </div>

        <div v-if="offer.color && offer.available" class="product-card__colors">
            <product-colors-list
                :offers="currentOffers"
                :current-offer="offer"
                :is-hidden-single="false"
                @select-color="onSelectColor"
            ></product-colors-list>
        </div>
        <div v-else class="product-card__colors-spy"></div>

        <router-link
            :to="productPath"
            class="product-card__header"
            @click.native.prevent="sendDataLayerEvent"
        >
            <div
                class="product-card__name"
                :class="{
                    'product-card__name--small': isSmall,
                }"
            >
                {{ productName }}
            </div>
        </router-link>

        <div class="product-card__footer">
            <div class="product-card__price">
                <product-price
                    :price="discountPrice"
                    :old-price="price"
                    :discount-count="discountPercent"
                    is-small-size
                ></product-price>
            </div>
            <product-card-buttons
                :offer-id="offerId"
                :product="product"
                :is-pre-order="isPreOrder"
                :in-cart="productInCart"
                :discount-price="discountPrice"
            ></product-card-buttons>
        </div>
    </div>
</template>

<style lang="scss">
    .product-card {
        position: relative;
        display: flex;
        flex-direction: column;
        height: auto;
        padding: 6px 6px 10px;
        background-color: #fff;
        border: 2px solid var(--primary-border);
        border-radius: var(--border-lg);
        transition: border-color 0.2s ease-in;
        &:hover,
        &:focus-within {
            border-color: #ececec;
            .product-card__name {
                color: var(--primary);
            }

            .product-card-image {
                img {
                    transform: scale(1);
                }
            }
        }

        @include bp($bp-desktop-sm-for-card) {
            padding: 10px 20px 20px;
        }
    }
    .product-card--sm {
        padding: 6px 10px 10px;
    }

    .product-card__img {
        position: relative;
        z-index: 2;
        overflow: hidden;
    }

    .product-card__sale-label {
        position: absolute;
        z-index: 2;
        left: 0;
        bottom: 6px;
        @include box(36px);
        color: #fff;
        font-size: 12px;
        font-weight: bold;
        line-height: 38px;
        text-align: center;
        border-radius: 50%;
        background-color: var(--danger);
        @include bp($bp-desktop-sm) {
            bottom: 10px;
            @include box(40px);
            font-size: 14px;
            line-height: 42px;
        }
    }

    .product-card__price {
        display: block;
        margin-bottom: 4px;
        @include bp($bp-desktop-sm) {
            margin-bottom: 8px;
        }
    }

    .product-card__header {
        margin-top: 12px;
        outline: none;
        @include bp($bp-desktop-sm) {
            margin-top: 16px;
        }
    }

    .product-card__footer {
        margin-top: auto;
    }

    .product-card__name {
        position: relative;
        z-index: 2;
        display: block;
        margin-bottom: 2px;
        color: var(--primary-text);
        font-size: 14px;
        font-weight: 500;
        line-height: 22px;
        transition: 0.3s ease-in-out all;
        @include bp($bp-desktop-sm) {
            margin-bottom: 5px;
            font-size: 18px;
        }
    }
    .product-card__name--small {
        font-size: 13px;
        line-height: 18px;
    }

    .product-card__colors {
        margin: 10px -4px 0;
        padding: 0 2px;
    }

    .product-card__colors-spy {
        height: 24px;
        margin-top: 10px;
    }

    .product-card__controls {
        margin-top: auto;
    }
</style>
